export interface PilotData {
  id: string;
  name: string;
  lat: number;
  lng: number;
  altitude: number;
  elevation?: number;
  speed: number;
  heading: number;
  vario: number;
  timestamp: number;
  color: string;
  flightState?: string;
  flightStateInfo?: any;
  flightTime?: number;
  maxSpeed?: number;
  avgSpeed?: number;
  altitudeChange?: number;
  source?: string;
  confidence?: string;
  totalPoints?: number;
  lastFixTime?: string;
  trackHistory?: any[];
}

export interface TaskWaypoint {
  seq: number;
  name: string;
  type: number;
  radius: number;
  coordinates: [number, number];
}

export interface Task {
  task_name: string;
  waypoints: TaskWaypoint[];
  goal_task_type?: string;
}

export interface MapViewProps {
  raceCenter: { lat: number; lng: number };
  raceName?: string;
  raceId?: string;
  selectedTask?: Task;
  showTask?: boolean;
  delayedTime?: Date;
}

export const WAYPOINT_COLORS: { [key: number]: string } = {
  0: '#00ff00',  // SSS - Green
  1: '#8B4513',  // GROUND - Brown
  2: '#FFA500',  // TAKE OFF - Orange
  3: '#8B4513',  // LANDING - Brown
  4: '#87CEEB',  // AIR - Light Blue
  5: '#9370DB',  // TOP - Purple
  6: '#808080',  // GENERIC - Gray
  7: '#FFD700',  // SIGN OFF - Gold
  8: '#FF69B4',  // ESS - Pink
  9: '#FF0000',  // GOAL - Red
};

export const WAYPOINT_TYPE_NAMES: { [key: number]: string } = {
  0: 'SSS',
  1: 'GROUND',
  2: 'TAKE OFF',
  3: 'LANDING',
  4: 'AIR',
  5: 'TOP',
  6: 'GENERIC',
  7: 'SIGN OFF',
  8: 'ESS',
  9: 'GOAL'
};